// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"47":"79054754","48":"d929c01e","447":"92143dda","491":"5a20ae70","574":"87c511f5","634":"c6cd8579","723":"57d54760","999":"09f1ec3f"}[chunkId] + ".js";
};